import { createRouter, createWebHashHistory } from 'vue-router'
import SupportView from '@/support/SupportView.vue'
import MarketingView from '@/marketing/MarketingView.vue'
import DashboardView from '@/dashboard/DashboardView.vue'
import LoginView from '@/login/LoginView.vue'
import AgencyDialog from '@/components/AgencyDialog.vue';
import CustomerDialog from '@/components/customerDialog/CustomerDialog.vue';
import TableDialog from '@/components/tableDialog/TableDialog.vue';
import LeadDialog from '@/components/leadDialog/LeadDialog.vue';
import RawLeadDialog from '@/components/rawLeadDialog/RawLeadDialog.vue'
import StatisticsView from '@/statistics/StatisticsView.vue';
import LeadSourceView from '@/statistics/subroutes/LeadSourceView.vue';
import EmailConnectionsView from '@/statistics/subroutes/EmailConnectionsView.vue';
import TableStatisticsView from '@/statistics/subroutes/TableStatisticsView.vue';
import CustomerStatisticsView from '@/statistics/subroutes/CustomerStatisticsView.vue';
import AgencyStatisticsView from '@/statistics/subroutes/AgencyStatisticsView.vue';
import CustomerLoginStatisticsView from '@/statistics/subroutes/CustomerLoginStatisticsView.vue';
import WhatsAppConnectionsStatistics from '@/statistics/subroutes/WhatsAppConnectionsStatistics.vue'
import WhatsAppConnectionsPerAgencyStatistics from '@/statistics/subroutes/WhatsAppConnectionsPerAgencyStatistics.vue'
import WhatsAppMessagesStatistics from '@/statistics/subroutes/WhatsAppMessagesStatistics.vue'
import WhatsAppMessagesPerAgencyCustomerView from '@/statistics/subroutes/WhatsAppMessagesPerAgencyCustomerView.vue'
import WhatsAppUsage from '@/statistics/subroutes/WhatsAppUsage.vue'

import store from '@/store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/support',
    name: 'support',
    component: SupportView
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: StatisticsView,
    redirect: '/statistics/lead-source',
    children: [
      {
        path: 'lead-source',
        name: 'lead-source',
        component: LeadSourceView
      },
      {
        path: 'email-connections',
        name: 'email-connections',
        component: EmailConnectionsView
      },
      {
        path: 'table-statistics',
        name: 'table-statistics',
        component: TableStatisticsView
      },
      {
        path: 'customer-statistics',
        name: 'customer-statistics',
        component: CustomerStatisticsView
      },
      {
        path: 'agency-statistics',
        name: 'agency-statistics',
        component: AgencyStatisticsView
      },
      {
        path: 'customer-login-statistics',
        name: 'customer-login-statistics',
        component: CustomerLoginStatisticsView
      },
      {
        path: 'whatsapp-connections',
        name: 'whatsapp-connections',
        component: WhatsAppConnectionsStatistics
      },
      {
        path: 'whatsapp-connections-per-agency',
        name: 'whatsapp-connections-per-agency',
        component: WhatsAppConnectionsPerAgencyStatistics
      },
      {
        path: 'whatsapp-messages',
        name: 'whatsapp-messages',
        component: WhatsAppMessagesStatistics
      },
      {
        path: 'whatsapp-messages-per-agency-customer',
        name: 'whatsapp-messages-per-agency-customer',
        component: WhatsAppMessagesPerAgencyCustomerView
      },
      {
        path: 'whatsapp-usage',
        name: 'whatsapp-usage',
        component: WhatsAppUsage
      }
    ]
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: MarketingView
  },
  {
    path: '/agency/:agencyId',
    component: AgencyDialog,
    props: true,
    name: 'agency',
  },
  {
    path: '/customer/:customerId',
    component: CustomerDialog,
    props: true,
    name: 'customer',
  },
  {
    path: '/table/:tableId',
    component: TableDialog,
    props: true,
    name: 'table',
  },
  {
    path: '/lead/:leadId',
    component: LeadDialog,
    props: true,
    name: 'lead',
  },
  {
    path: '/raw-lead/:rawLeadId',
    component: RawLeadDialog,
    props: true,
    name: 'raw-lead',
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'dashboard' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const token = store.state.loginAndOut.token;
  if (!token && to.name !== 'login') { // if there's no token and the user is not navigating to 'login'
    next({ name: 'login' }); // redirect to login
  } else {
    next(); // otherwise continue as normal
  }
});

export default router
